/**
 * Custom Controller Wrapper
 * 
 * @Author: Focci
 * @Date: 2023-07-13 17:40:13
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-13 17:40:13
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { ButtonBase } from '@comp/material'

export default function ControllerWrapper({
  children,
  className = 'shadow-large rounded-md',
  style = null,
  isSelected = false,
  small = false,
  ...buttonProps
}) {
  return (
    <ButtonBase
      className="rounded-md"
      {...buttonProps}
    >
      <div 
        className={clsx([
          isSelected && 'border border-2 border-solid border-primary',
          buttonProps.disabled && '!bg-gray-100',
          small ? 'w-9 h-9' : 'w-14 h-14',
          'flex items-center justify-center bg-white',
          'hover:bg-cf0 cursor-pointer overflow-hidden',
          className,
        ])}
        style={style}
      >
        <div className={clsx([buttonProps.disabled && 'opacity-50'])}>
          {children}
        </div>
      </div>
    </ButtonBase>
  )
}

ControllerWrapper.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isSelected: PropTypes.bool,
  small: PropTypes.bool,
}
